import React, { Suspense } from "react";
import GlobalStyle from "manifest-components/src/Styles";
import { BrowserRouter as Router } from "react-router-dom";
import { PrimerThemeProvider } from "manifest-components/src/Popover/Popover";
import VersionProvider from "./context/Version/versionProvider";
import VersionNotifier from "./components/VersionNotifier";
import Routes from "./routes/AppRoutes";
import DevVersionIndicator from "./components/VersionIndicator";
import { clearCookiesOnStartup, migrateStorageToCookies } from "./utils/session";
import AppProvider from "./context/App/appProvider";
import DevelopmentEnvironmentProvider from "./context/DevelopmentEnvironment/developmentEnvironmentProvider";
import UserProvider from "./context/User/userProvider";
import { isLocalEnvironment } from "./env";

// if (envVariables.REACT_APP_HEAP_ID && window.heap && typeof window.heap.load === "function") {
//   window.heap.load(envVariables.REACT_APP_HEAP_ID);
// }

// Perform any migration before starting the app
clearCookiesOnStartup();
migrateStorageToCookies();

// Sentry error logging integration (Do not enable for local dev, it logs too many errors)
if (!isLocalEnvironment()) {
  // Sentry.init({
  //   environment: getEnvironmentName(),
  //   dsn: "NEED_URL",
  //   integrations: [new Integrations.BrowserTracing()],
  //   tracesSampleRate: 1.0,
  // });
}

export default function App() {
  return (
    <>
      <Router>
        <VersionProvider>
          <AppProvider>
            <DevelopmentEnvironmentProvider>
              <PrimerThemeProvider>
                <GlobalStyle>
                  <DevVersionIndicator />
                  <VersionNotifier />
                  <UserProvider>
                    <Suspense fallback={null}>
                      <Routes />
                    </Suspense>
                  </UserProvider>
                </GlobalStyle>
              </PrimerThemeProvider>
            </DevelopmentEnvironmentProvider>
          </AppProvider>
        </VersionProvider>
      </Router>
    </>
  );
}
